(function(){
  // mobile nav
  var t=document.querySelector('[data-nav-toggle]');
  if(t){t.addEventListener('click',function(){var n=document.querySelector('.hdr-nav');var o=n.classList.toggle('open');t.setAttribute('aria-expanded',o);});}

  // money
  function money(cents){
    var f=(window.theme&&window.theme.moneyFormat)||'${{amount}}';
    var v=(cents/100).toFixed(2);
    var parts=v.split('.'); parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
    var withComma=parts.join('.');
    return f.replace(/\{\{\s*amount\s*\}\}/,withComma)
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/,parts[0])
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/,v.replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g,'.'))
            .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/,parts[0].replace(/,/g,'.'));
  }

  // product variants
  var form=document.querySelector('[data-product-form]');
  var data=document.querySelector('[data-variants]');
  if(form&&data){
    var variants=JSON.parse(data.textContent);
    var selects=form.querySelectorAll('[data-option-index]');
    var idInput=form.querySelector('[data-variant-id]');
    var btn=form.querySelector('[data-add-btn]');
    var priceEl=document.querySelector('[data-price]');
    var cmpEl=document.querySelector('[data-compare]');
    var mainImg=document.getElementById('MainImage');
    function update(){
      var opts=Array.prototype.map.call(selects,function(s){return s.value;});
      var v=variants.find(function(x){return opts.every(function(o,i){return x.options[i]===o;});});
      if(!v){btn.disabled=true;btn.textContent='Unavailable';return;}
      idInput.value=v.id;
      priceEl.textContent=money(v.price);
      if(v.compare_at_price&&v.compare_at_price>v.price){cmpEl.textContent=money(v.compare_at_price);cmpEl.hidden=false;}else{cmpEl.hidden=true;}
      btn.disabled=!v.available; btn.textContent=v.available?'Add to cart':'Sold out';
      if(v.featured_image&&window.showImageById){window.showImageById(v.featured_image.id);}
      if(history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);}
    }
    selects.forEach(function(s){s.addEventListener('change',update);});


    // ajax add to cart
    form.addEventListener('submit',function(e){
      if(e.submitter&&e.submitter.closest('.shopify-payment-button'))return;
      e.preventDefault();
      var fd=new FormData(form);
      btn.disabled=true; var old=btn.textContent; btn.textContent='Adding…';
      fetch(window.theme.routes.cartAdd+'.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}})
        .then(function(r){return r.json();})
        .then(function(){return fetch(window.theme.routes.cart+'.js').then(function(r){return r.json();});})
        .then(function(c){
          var cc=document.querySelector('[data-cart-count]'); if(cc)cc.textContent=c.item_count;
          btn.textContent='Added — view cart';
          btn.onclick=function(){location.href=window.theme.routes.cart;};
          btn.disabled=false;
        })
        .catch(function(){btn.textContent=old;btn.disabled=false;form.submit();});
    });
  }
})();

/* ===== product gallery + lightbox ===== */
(function(){
  var g=document.querySelector('[data-gallery]'); if(!g)return;
  var images=JSON.parse(g.querySelector('[data-images]').textContent);
  var main=document.getElementById('MainImage');
  var thumbs=Array.prototype.slice.call(g.querySelectorAll('.thumb'));
  var idx=parseInt(main&&main.dataset.index||'0',10)||0;
  function show(i){
    if(!images.length)return; idx=(i+images.length)%images.length;
    if(main){main.style.opacity=.4;main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=images[idx].large;main.alt=images[idx].alt;var done=function(){main.style.opacity=1;};main.onload=done;setTimeout(done,700);}
    thumbs.forEach(function(t,j){t.classList.toggle('active',j===idx);});
  }
  window.showImageById=function(id){var i=images.findIndex(function(x){return x.id===id;});if(i>-1)show(i);};
  thumbs.forEach(function(t){t.addEventListener('click',function(){show(parseInt(t.dataset.index,10));});});

  var lb=document.querySelector('[data-lightbox]'); if(!lb)return;
  var lbImg=lb.querySelector('[data-lb-img]'),count=lb.querySelector('[data-lb-count]'),strip=lb.querySelector('[data-lb-strip]');
  images.forEach(function(im,i){var b=document.createElement('button');b.type='button';b.innerHTML='<img src="'+im.thumb+'" alt="">';b.addEventListener('click',function(){lbShow(i);});strip.appendChild(b);});
  var sb=strip.querySelectorAll('button');
  function lbShow(i){idx=(i+images.length)%images.length;lbImg.src=images[idx].full;lbImg.alt=images[idx].alt;count.textContent=(idx+1)+' / '+images.length;sb.forEach(function(b,j){b.classList.toggle('active',j===idx);});var a=sb[idx];if(a&&a.scrollIntoView)a.scrollIntoView({block:'nearest',inline:'center'});show(idx);}
  function open(){lb.hidden=false;lb.classList.add('open');document.body.style.overflow='hidden';lbShow(idx);lb.querySelector('[data-lb-close]').focus();}
  function close(){lb.classList.remove('open');lb.hidden=true;document.body.style.overflow='';}
  g.querySelector('[data-lb-open]').addEventListener('click',open);
  lb.querySelector('[data-lb-close]').addEventListener('click',close);
  lb.querySelector('[data-lb-prev]').addEventListener('click',function(){lbShow(idx-1);});
  lb.querySelector('[data-lb-next]').addEventListener('click',function(){lbShow(idx+1);});
  lb.addEventListener('click',function(e){if(e.target===lb)close();});
  document.addEventListener('keydown',function(e){if(lb.hidden)return;if(e.key==='Escape')close();if(e.key==='ArrowLeft')lbShow(idx-1);if(e.key==='ArrowRight')lbShow(idx+1);});
  var sx=null;lb.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
  lb.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>50)lbShow(dx<0?idx+1:idx-1);sx=null;});
})();

/* ===== related products (Shopify recommendations API) ===== */
(function(){
  var el=document.querySelector('[data-related]'); if(!el)return;
  fetch(el.dataset.url).then(function(r){return r.text();}).then(function(html){
    var d=document.createElement('div');d.innerHTML=html;
    var inner=d.querySelector('[data-related]');
    if(inner&&inner.querySelector('.product')){el.innerHTML=inner.innerHTML;}
  }).catch(function(){});
})();
